(function () {
  'use strict';

  function parseReviewDate(isoDate) {
    if (!isoDate) return null;
    var value = String(isoDate).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      var parts = value.split('-').map(Number);
      return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    var date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function formatRelativeTime(isoDate) {
    var date = parseReviewDate(isoDate);
    if (!date) return null;

    var diffMs = Date.now() - date.getTime();
    if (diffMs < 0) return 'just now';

    var minutes = Math.floor(diffMs / 60000);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var weeks = Math.floor(days / 7);
    var months = Math.floor(days / 30);
    var years = Math.floor(days / 365);

    if (minutes < 1) return 'just now';
    if (minutes < 60) return minutes === 1 ? '1 minute ago' : minutes + ' minutes ago';
    if (hours < 24) return hours === 1 ? '1 hour ago' : hours + ' hours ago';
    if (days < 7) return days === 1 ? '1 day ago' : days + ' days ago';
    if (days < 30) return weeks === 1 ? '1 week ago' : weeks + ' weeks ago';
    if (days < 365) return months === 1 ? '1 month ago' : months + ' months ago';
    return years === 1 ? '1 year ago' : years + ' years ago';
  }

  function initReviewTimes(root) {
    var scope = root || document;
    scope.querySelectorAll('time.nr-reviews__time[datetime]').forEach(function (el) {
      if (!el.title) el.title = el.textContent.trim();
      var relative = formatRelativeTime(el.getAttribute('datetime'));
      if (relative) el.textContent = relative;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReviewTimes();
    });
  } else {
    initReviewTimes();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReviewTimes(event.target);
  });
})();
